import { PlantsEnum } from '@cpak/adp-cpak-quotes-service-models';

export const defaultMaxCharactersForHouston = 30;
export const defaultMaxCharactersForPuurs = 40;

export const plantToMaxCharacters = new Map<PlantsEnum, number>([
  [PlantsEnum.houston, defaultMaxCharactersForHouston],
  [PlantsEnum.puurs, defaultMaxCharactersForPuurs],
]);

export const allowedCharsPattern = '[^\\\\\'\\]<>"&|/{}#*[?%:^@;]+';
export const restrictedChars = '< > \' " & | / \\ { } # * [ ] ? % : ^ @ ;';
